export default "__VITE_ASSET__B8sIP16E__"